import React from "react";
import TextBox from '../../components/Textbox';

export default ({ bgImg, engagementData, manageTool }) => {
  let textBoxId = 'enp_collaboration_eng_2_2B';
  return <div style={{ height: '100%',backgroundColor:'white' }}>
    <div style={{ width: '100%', display: 'flex'}}>
      <div style={{ height: '115px', padding: '24px', backgroundColor: '#e4e7ec', fontSize: '1.25rem', fontWeight: 'bold', color: '#264a69',width: '100%', }}>
        What practices &amp; engagement strategies should be adopted by any of us, if we want to demonstrate
        ‘Trust Communication’?
    <br />
        <span style={{ fontSize: '14px', color: 'black', fontWeight:'400'}}>Open Discussion</span>
      </div>
    </div>
    <div style={{ display: "flex", padding: '8px', backgroundColor: '#e2f488', height: 'calc(100% - 155px)', borderRadius: '25px', boxShadow: 'rgb(195 195 195) 10px 10px 6px -6px', margin: '5px 25px 15px 25px' }}>
      <div style={{ padding: '0px 16px', width: '45%' }}>
        <img style={{ height: '100%' }} src={bgImg} />
      </div>
      <div style={{ padding: '20px', border: '3px solid black', flexGrow: '1', borderRadius: '24px', display: 'flex', flexDirection: 'column', backgroundColor: "#fdff9b" }}>
        <div>
          <strong>
            Enabling practices &amp; engagement strategies:
          </strong>
        </div>
        <TextBox id={textBoxId} initialData={engagementData[textBoxId] || null} processData={manageTool} />
      </div>
    </div>
    <div style={{ width: '100%', padding: '0px 15px', backgroundColor: 'white', fontWeight: 'bold' }}>
      PREPARED FOR TATA STEEL HR
      </div>
  </div>
}